//BT-114264 : Showing trending scrips in search : ManasaB : 11/08/2023  - Start
import { memo } from 'react';
import { Row, Col, Container } from 'react-bootstrap';
//Vaibhav Singh: 22-11-23: Onchangevalue passed for Trending Search: Start
const TrendingSearch = ({ arrTrendingScrips, onChangeGlobalSearch }) => {
//Vaibhav Singh: 22-11-23: Onchangevalue passed for Trending Search: End
    return (
        <>
            {
                arrTrendingScrips.length > 0 &&
                <Container fluid className='p-0 px-3'>
                     <Row className='g-0 mt-4'> 
                        <Col className='d-flex align-items-center'>
                            <div class='icon-20 icon-trending icon-dark me-3'></div>
                            <div className='font-medium font-size3 color-text'>Trending</div>
                        </Col>                        
                    </Row>
                    <Row className='g-0 py-3'>
                        <Col>                              
                            <div className='chips-wrap'>                               
                                {arrTrendingScrips.map((eachScrip, i) => {
                                    return(   
                                            <div className='multi-chip mb-2 me-3' key={i} onClick={()=>{onChangeGlobalSearch({target:{value:eachScrip}})}}>{eachScrip}</div>
                                        )
                                        }
                                    )
                                }                                 
                            </div>
                        </Col>                        
                    </Row>  
                </Container>
            }
        </>
    );
};

export default memo(TrendingSearch);
//BT-114264 : Showing trending scrips in search : ManasaB : 11/08/2023 - End